import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import Navigation from '@common/Navigation.vue';
import { ICommandBase } from '@Quest/cqrs';
import { SaveViewOwnerProjectsPageCommandV1 } from "@Quest/Portfolios/Domain/commands-core";
import PortfoliosCommands from "@Quest/Portfolios/Domain/commands-vue-component";
import { ProjectsGridViewModel } from "@Quest/Projects/Components/ProjectsGrid";
import ProjectsGrid from "@Quest/Projects/Components/ProjectsGrid.vue";
import ProjectsCommands from "@Quest/Projects/Domain/commands-vue-component";
import ProjectsQueries from "@Quest/Projects/Domain/queries-vue-component";
import { MyPortfolioProjectsPageReadModel, GridProjectReadModel } from "@Quest/Projects/Domain/readmodels";
import Vue from "vue";
import Component, { mixins } from 'vue-class-component';


@Component({
    components: {
        Navigation, PortfolioNavigation, ProjectsGrid
    }
})
export default class MyPortfolioProjectsPage extends mixins(ProjectsCommands, ProjectsQueries, PortfoliosCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get tchProjectId() { return Number.parseInt(this.$route.params.tchProjectId); }

    rm: MyPortfolioProjectsPageReadModel | null = null;
    get projects(): GridProjectReadModel[] { return this.rm?.Projects ?? []; }
    get portfolioId() { return this.rm.PortfolioId; }
    get portfolioName(): string | null { return this.rm?.PortfolioName; }
    get isWorkspaceMember(): boolean { return this.rm?.IsWorkspaceMember ?? false }

    grid: ProjectsGridViewModel = new ProjectsGridViewModel();

    selectedIds: string[] = [];


    handleClearGridFilters()
    {
        this.grid.clearFilters();
    }

    handleExportGrid()
    {
        this.grid.exportGrid();
    }


    handleShowGridColumnsEditor()
    {
        this.grid.showGridColumnsEditor();
    }

    handleSaveViewSettings()
    {
        const grid = this.grid.getJson();
        this.invokeSaveViewOwnerProjectsPageCommandV1(this.workspaceId, this.portfolioId, grid)
    }


    mounted()
    {
        document.title = "Project owner | TransparentChoice";
        this.runMyPortfolioProjectsPageQueryV1(this.workspaceId, this.tchProjectId);
    }

    onSetModel(model: any, modelName: string): void 
    {
        if (modelName === "MyPortfolioProjectsPageReadModel")
        {
            this.rm = model as MyPortfolioProjectsPageReadModel;

            Vue.nextTick(() =>
            {
                const getSelectedIds = (e: any) =>
                {
                    const selectedRows = e.sender.select();

                    const ids: string[] = [];

                    for (const r of selectedRows)
                    {
                        const dataItem = e.sender.dataItem(r);
                        ids.push(dataItem[this.rm.Grid.IdField] as string);
                    }

                    this.selectedIds = [...new Set(ids)];
                }

                this.grid.renderGrid(this.rm.Grid.IdField, this.rm.Grid.Fields, this.rm.Grid.DefaultFieldIds, this.rm.Grid.Options, getSelectedIds);

                this.grid.setProjects(this.rm.Projects.map(p => p.Properties));
            })
        }
        else if (modelName === "GridProjectReadModel")
        {
            const rm = model as GridProjectReadModel;

            this.rm.Projects = this.rm.Projects.filter(p => p.Id !== rm.Id);
            this.rm.Projects.push(rm);

            this.grid.update(rm.Properties);
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (SaveViewOwnerProjectsPageCommandV1.matchType(cmd))
        {
            alert("Saved");
        }
    }
}
